module.exports = __webpack_public_path__ + "static/media/individual_podcast.997d2a58.png";